
import { defineComponent, SetupContext, ref, onMounted } from "vue";
import NativeClient from "@/client/native-client";
import store from "@/store";
import {
  RecognitionCandidate,
  CandidateInfo,
  RequestRecognitionCandidateItem,
  RecognitionCandidateMap,
  StatusCameraCheck,
  CHECK_SCREEN_STATUS,
  CONFIRM_USER_NEW,
  DEFALT_FOOD_ID
} from "@/types/pantry";
import PantryFoodCheckItem from "./PantryFoodCheckItem.vue";
import PantryCameraCheckImageView from "./PantryCameraCheckImageView.vue";
import PantrySelectCategory from "./PantrySelectCategory.vue";
export default defineComponent({
  name: "PantryCameraCheckView",
  components: {
    PantrySelectCategory,
    PantryFoodCheckItem,
    PantryCameraCheckImageView
  },
  props: {
    id: {
      type: Number,
      default: -1,
      required: true
    },
    selectPosition: {
      type: Number,
      default: 0,
      required: true
    },
    food: {
      type: RequestRecognitionCandidateItem,
      default: null,
      required: true
    },
    update: {
      type: Number,
      default: 0,
      require: true
    },
    isFoodTimerExec: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const fileName = ref("");
    const createCandidateData = () => {
      NativeClient.sendDebugLog("PantryCameraCheckView setCandidateData key=" + props.id + " foodList=" + JSON.stringify(props.food));
      let applianceId = null;
      let inferenceResultFoodId = DEFALT_FOOD_ID;
      const map: RecognitionCandidateMap = store.getters["pantry/getRecognitionCandidateMap"];
      let candidateData = null;
      if (props.food) {
        applianceId = props.food.applianceId;
        inferenceResultFoodId = props.food.inferenceResultFoodId;
        if (map && map.map) {
          candidateData = map.map.get(inferenceResultFoodId);
        }
      }
      const candidate = new RecognitionCandidate(props.id, inferenceResultFoodId, applianceId);;
      if (candidateData != null && candidateData.info) {
        candidate.set(candidateData.info);
      }
      return candidate;
    };
    const candidateData = ref(createCandidateData());
    const categoryNameList = ref(Array<string>());
    categoryNameList.value.push("新しく入れた");
    categoryNameList.value.push("前からある");
    const selectNo = ref(0);
    const userNew = ref(CONFIRM_USER_NEW.USER_NEW);
    // 表示更新のためのリアクティブ
    const updateSelectItemKey = ref(0);
    const updateSelectItem = () => {
      if (updateSelectItemKey.value >= 100) {
        updateSelectItemKey.value = 0;
      } else {
        updateSelectItemKey.value++;
      }
    };
    NativeClient.sendDebugLog("PantryCameraCheckView candidateData=" + JSON.stringify(candidateData));
    const isShow = () => {
      NativeClient.sendDebugLog("PantryCameraCheckView isShow selectPosition=" + props.selectPosition + " id=" + props.id);
      return (props.selectPosition == props.id);
    };
    const isShowData = () => {
      return (candidateData.value.info != null)
    };
    const getFoodName = () => {
      NativeClient.sendDebugLog("PantryCameraCheckView getFoodName data=" + JSON.stringify(candidateData.value));
      const food = (candidateData.value && candidateData.value.info) ? candidateData.value.info.name : "";
      return "これは新しくいれた「" + food + "」ですか？";
    };
    const getMainFood = () => {
      let result = null;
      if (candidateData.value && candidateData.value.info) {
        result = new CandidateInfo();
        result.imageUrl = candidateData.value.info.ingredientImageUrl;
        result.name = candidateData.value.info.name;
        result.ingredientId = candidateData.value.info.ingredientId;
      }
      return result;
    };
    const getFoodList = () => {
      return (candidateData.value.info && candidateData.value.info.candidates) ? candidateData.value.info.candidates : null;
    };
    const onClickFood = (data: CandidateInfo) => {
      const inferenceResultFoodId = props.food ? props.food.inferenceResultFoodId : DEFALT_FOOD_ID;
      NativeClient.sendDebugLog("PantryCameraCheckView onClickFood inferenceResultFoodId=" + inferenceResultFoodId + " data=" + JSON.stringify(data));
      data.userNew = userNew.value;
      context.emit("click-food", inferenceResultFoodId, data);
    };
    const clickInput = () => {
      const inferenceResultFoodId = props.food ? props.food.inferenceResultFoodId : DEFALT_FOOD_ID;
      candidateData.value.userNew = userNew.value;
      NativeClient.sendDebugLog("PantryCameraCheckView clickInput inferenceResultFoodId=" + inferenceResultFoodId);
      context.emit("click-input", inferenceResultFoodId, candidateData.value);
    };
    const setStatus = (status: number) => {
      const item = new StatusCameraCheck(props.id, props.food.inferenceResultFoodId, status);
      context.emit("status", item);
    };
    const showLoading = () => {
      store.dispatch("common/startLoading");
      setStatus(CHECK_SCREEN_STATUS.STATUS_API_EXEC);
    };
    const stopLoading = () => {
      store.dispatch("common/stopLoading");
      setStatus(CHECK_SCREEN_STATUS.STATUS_NONE);
    };
    const setCandidateData = () => {
      const map: RecognitionCandidateMap = store.getters["pantry/getRecognitionCandidateMap"];
      if (map && map.map && candidateData.value.inferenceResultFoodId) {
        const candidate = map.map.get(candidateData.value.inferenceResultFoodId);
        if (candidate != null && candidate.info) {
          candidateData.value.set(candidate.info);
          updateSelectItem();
        }
      }
      stopLoading();
    };
    const requestRecognitionCandidate = async () => {
      if (candidateData.value.inferenceResultFoodId && candidateData.value.applianceId) {
        const payload = new RequestRecognitionCandidateItem(candidateData.value.inferenceResultFoodId, candidateData.value.applianceId)
        NativeClient.sendDebugLog("PantryCameraCheckView requestRecognitionCandidate payload=" + JSON.stringify(payload));
        await Promise.all([
          store.dispatch("pantry/getRecognitionCandidate", payload)
        ]).then(result => {
          NativeClient.sendDebugLog("PantryCameraCheckView requestRecognitionCandidate result");
          setCandidateData();
        });
      }
    };
    const execute = async () => {
      NativeClient.sendDebugLog("PantryCameraCheckView execute selectPosition=" + props.selectPosition + " id=" + props.id);
      NativeClient.sendDebugLog("PantryCameraCheckView execute candidateData=" + JSON.stringify(candidateData));
      if (candidateData.value.info == null && props.selectPosition == props.id) {
        showLoading();
        requestRecognitionCandidate();
      }
    };

    const selectCategory = (index: number) => {
      NativeClient.sendDebugLog("PantryCameraCheckView selectCategory=" + index);
      switch (index) {
        case 0:
          userNew.value = CONFIRM_USER_NEW.USER_NEW;
          break;
        case 1:
          userNew.value = CONFIRM_USER_NEW.USER_ALREADY_EXISTS;
          break;
      }
    };

    const onClickImageView = () => {
      NativeClient.sendDebugLog("PantryCameraCheckView onClickImageView fileName=" + fileName.value);
      if (fileName.value != "") {
        context.emit("select-image", fileName.value);
      }
    };

    const callbackImageFileName = (name: string) => {
      NativeClient.sendDebugLog("PantryCameraCheckView callbackImageFileName name=" + name);
      fileName.value = name;
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      execute();
    });

    return {
      isShow,
      isShowData,
      getFoodName,
      getMainFood,
      getFoodList,
      onClickFood,
      clickInput,
      updateSelectItemKey,
      candidateData,
      categoryNameList,
      selectCategory,
      selectNo,
      onClickImageView,
      callbackImageFileName
    };
  }
});
